import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue"
import SearchInput from "@/components/widgets/common/SearchInput.vue"
import {
  ConsultantApplicationsQuery,
  ConsultantApplicationsQueryQuery,
  ConsultantApplicationsQueryQueryVariables,
  SortDirection,
  OpenMissionStaffingPositionsFilter,
  MissionStaffingApplicationFragmentFragment,
} from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import ApplicationsOverview from "./ApplicationsOverview.vue"
import RecordOverview from "./RecordOverview.vue"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import { useUtilities } from "@/hooks/useUtilities"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationsTab',
  setup(__props) {

const filters = ref<OpenMissionStaffingPositionsFilter>({})
const searchInput = ref("")

const { debounceCall } = useUtilities()
const { t } = useTranslation("Consultant/Opportunities")

const debounceSearch = debounceCall(() => {
  filters.value = {
    ...filters.value,
    search: searchInput.value || undefined,
  }
}, 700)

watch(searchInput, () => {
  if (!searchInput.value) {
    filters.value = {
      ...filters.value,
      search: undefined,
    }
  } else {
    debounceSearch()
  }
})

const pageState = ref(PageState.Loading)
const selectedApplication = ref<MissionStaffingApplicationFragmentFragment | null>(null)

const pagination = ref({
  page: 1,
  per: 10,
  length: 1,
})

const { handlePageErrorState } = usePageState(pageState)

const { loading, result, onError, onResult } = useQuery<
  ConsultantApplicationsQueryQuery,
  ConsultantApplicationsQueryQueryVariables
>(
  ConsultantApplicationsQuery,
  computed(() => ({
    filter: {
      ...filters.value,
    },
    paginate: {
      per: pagination.value.per,
      page: pagination.value.page,
    },
    sort: {
      createdAt: SortDirection.Desc,
    },
  }))
)

const refetchQueries = computed(() => {
  return [
    {
      query: ConsultantApplicationsQuery,
      variables: {
        filter: filters.value,
      },
    },
  ]
})

onError((error) => {
  handlePageErrorState(error)
})

onResult((result) => {
  pagination.value.length =
    result?.data?.consultantProfile?.missionStaffingApplications?.pagination?.pageCount || 0

  if (result?.data?.consultantProfile?.missionStaffingApplications?.data.length) {
    selectedApplication.value = result.data.consultantProfile.missionStaffingApplications.data[0]
    return
  }
  selectedApplication.value = null
})

const onApplicationClick = (application: MissionStaffingApplicationFragmentFragment) => {
  selectedApplication.value = application
  window.scrollTo(0, 0)
}

const onResetFilters = () => {
  filters.value = {}
}

const isSearchEmpty = computed(() => {
  return !searchInput.value
})

const getApplicationsMessage = computed(() => {
  return isSearchEmpty.value
    ? t("noApplicationsMessage.noApplications")
    : t("noApplicationsMessage.noApplicationsFoundSearch", {
        searchInput: searchInput.value,
      })
})

return { __sfc: true,filters, searchInput, debounceCall, t, debounceSearch, pageState, selectedApplication, pagination, handlePageErrorState, loading, result, onError, onResult, refetchQueries, onApplicationClick, onResetFilters, isSearchEmpty, getApplicationsMessage, SearchInput, ApplicationsOverview, RecordOverview, PageState, PageStateError }
}

})